<template>
    <tr class="table-item">
        <td>
            <v-checkbox
                v-model="isActive"
                :ripple="false"
                hide-details
            ></v-checkbox>
        </td>

        <td>
            {{ item.name }}
        </td>
    </tr>
</template>

<script>
export default {
    components: {},

    data() {
        return {};
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
        },
    },
    computed: {
        isActive: {
            get() {
                return this.value.includes(this.item.id);
            },

            set(val) {
                this.emitChange(val);
            },
        },
    },
    methods: {
        emitChange(event) {
            const action = event ? "select" : "deselect";
            this.$emit("change", { action, id: this.item.id });
        },
    },
};
</script>

<style lang="scss" scoped>
.table-item {
    &:last-child {
        margin-right: 0;
    }
}
</style>
